export const ConsultType = {
  INITIAL: 'initial consult',
  CHECKUP: 'checkup',
} as const;

export type TimeUnitUpdateConsultWaitTime = 'DAY' | 'WEEK' | 'MONTH';
